import { Form, Table } from "react-bootstrap";
import { useState } from "react";
import AddCustomer from "./AddCustomer";
import UpdateCustomer from "./UpdateCustomer";
import Moment from "react-moment";
import { useEffect } from "react";
import Swal from "sweetalert2";
import UseToggle from "../../../../../Hooks/UseToggle";
import { storeCustomerServices } from "../../../../../APIServices/SitePilotManagement/StoreManagement/storeCustomerServices";
import ToolBar from "../../../../Componant/ToolBar";
import CustomerData from "./CustomerData";

const CustomerManagement = () => {
  const toggles = UseToggle();
  const [search, setSearch] = useState("");
  const [loader, setLoader] = useState(false);
  const [storeCategories, setStoreCategories] = useState([]);
  const [storeCustomerData, setStoreCustomerData] = useState("");
  const [storeCustomerCount, setStoreCustomerCount] = useState(0);
  const [storeCustomerIds, setStoreCustomerIds] = useState([]);
  const [customerData, setCustomerData] = useState("");
  const [showPreview, setShowPreview] = useState(false);

  const toggleSingle = (id) => {
    setStoreCustomerIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
    );
  };

  const toggleAll = () => {
    if (storeCustomerIds.length === storeCategories.length) {
      setStoreCustomerIds([]);
    } else {
      setStoreCustomerIds(storeCategories.map((c) => c.id));
    }
  };

  const isAllChecked =
    storeCategories.length > 0 &&
    storeCustomerIds.length === storeCategories.length;
  const isChecked = (id) => storeCustomerIds.includes(id);

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const totalPages = Math.ceil(storeCustomerCount / itemsPerPage);

  const start = (pageNumber - 1) * itemsPerPage + 1;
  const end = Math.min(pageNumber * itemsPerPage, storeCustomerCount);

  const getStoreCustomerList = async () => {
    setLoader(true);
    let data = await storeCustomerServices.getStoreCustomerList(
      "all",
      search,
      pageNumber,
      itemsPerPage,
    );
    setStoreCategories(data?.data || []);
    setStoreCustomerCount(data?.count || 0);
    setLoader(false);
  };

  const updatedStoreCustomer = async (customerId, status) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to ${status} this Store Customer?`,
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${status} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.customerId = customerId;
        userData.status = status;
        userData.settings = "status";
        let data = await storeCustomerServices.updatedStoreCustomer(userData);
        if (data?.statusCode === 200) {
          getStoreCustomerList();
        }
      }
    });
  };

  const deleteStoreCustomer = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this Store Customer?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.customerIds = storeCustomerIds;
        let data = await storeCustomerServices.deleteStoreCustomer(userData);
        if (data?.statusCode === 200) {
          getStoreCustomerList();
        }
      }
    });
  };

  useEffect(() => {
    let storeCustomerData = storeCategories?.find(
      (item) => item.customerId === storeCustomerIds?.[0],
    );
    setStoreCustomerData(storeCustomerData || "");
  }, [storeCustomerIds]);

  useEffect(() => {
    getStoreCustomerList();
  }, [search, pageNumber, itemsPerPage]);

  return (
    <>
      <ToolBar
        toggles={toggles}
        search={search}
        setSearch={setSearch}
        checkedIds={storeCustomerIds}
        setCheckedIds={setStoreCustomerIds}
        showPreview={showPreview}
        setShowPreview={setShowPreview}
        setSelected={setCustomerData}
        start={start}
        end={end}
        totalItems={storeCustomerCount}
        page={pageNumber}
        setPage={setPageNumber}
        setPageSize={setItemsPerPage}
        pageSize={itemsPerPage}
        totalPages={totalPages}
        deleteData={deleteStoreCustomer}
        addField
        editField
      />
      <div className={`contacts-layout ${showPreview ? "with-preview" : ""}`}>
        <div
          className={`table-section overflow-auto bg-white ${showPreview ? "border-end" : ""}`}
          style={{ height: "calc(100vh - 106px)" }}
        >
          <Table
            hover
            className="contacts-table mb-0"
            style={{ verticalAlign: "middle" }}
          >
            <thead>
              <tr>
                <th style={{ width: "30%" }}>
                  <div className="d-flex align-items-center gap-2">
                    <div className="px-2">
                      <Form.Check
                        type="checkbox"
                        checked={isAllChecked}
                        onChange={toggleAll}
                        onClick={(e) => e.stopPropagation()}
                      />
                    </div>
                    <div>Customer</div>
                  </div>
                </th>
                {!customerData && (
                  <>
                    <th>Status</th>
                    <th>Created Date | Time</th>
                    <th>Updated Date | Time</th>
                  </>
                )}
              </tr>
            </thead>
            <tbody>
              {storeCategories?.map((item) => (
                <tr
                  key={item.customerId}
                  className={`contact-row ${customerData?.customerId === item.customerId ? "active" : ""}`}
                  onClick={() => {
                    setCustomerData(item);
                    setShowPreview(true);
                  }}
                >
                  <td
                    className="text-truncate text-wrap"
                    style={{ maxWidth: 100 }}
                  >
                    <div className="d-flex align-items-center gap-2">
                      <div className="px-2">
                        <Form.Check
                          type="checkbox"
                          checked={isChecked(item.customerId)}
                          onChange={() => toggleSingle(item.customerId)}
                          onClick={(e) => e.stopPropagation()}
                        />
                      </div>
                      <div>
                        <div className="fw-medium">{item.name}</div>
                        <small className="text-muted">{item.email}</small>
                      </div>
                    </div>
                  </td>
                  {!customerData && (
                    <>
                      <td className="text-capitalize">
                        {item?.status}
                      </td>
                      <td>
                        <span className="fw-medium">
                          <Moment format="DD MMM YYYY | HH:mm" withTitle>
                            {item?.createdAt}
                          </Moment>
                        </span>
                      </td>
                      <td>
                        <span className="fw-medium">
                          <Moment format="DD MMM YYYY | HH:mm" withTitle>
                            {item?.updatedAt}
                          </Moment>
                        </span>
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        <div className={`preview-section ${showPreview ? "open" : ""}`}>
          {customerData && (
            <div className="overflow-auto" style={{ height: "calc(100vh - 108px)" }}>
              <div className="preview-scroll p-0">
                <div className="preview-block">
                  <CustomerData customerData={customerData} getStoreCustomerList={getStoreCustomerList} />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <AddCustomer
        show={!toggles.toggle}
        hide={() => toggles.setToggle()}
        title={`Add Customer`}
        getStoreCustomerList={getStoreCustomerList}
      />
      <UpdateCustomer
        show={!toggles.toggle1}
        hide={() => toggles.setToggle1()}
        title={`Update Customer`}
        storeCustomerData={storeCustomerData}
        setStoreCustomerData={setStoreCustomerData}
        setStoreCustomerIds={setStoreCustomerIds}
        getStoreCustomerList={getStoreCustomerList}
      />
    </>
  );
};

export default CustomerManagement;
